module.exports = __webpack_public_path__ + "static/media/enhanced-hygiene.3217f6d0.webp";